import { TypeMetricUnit } from '@/pages/Insights/Insights.types';
import { secondsToHours, secondsToMinutes } from '@/pages/Insights/utils';
import { formatDuration, formatNumber } from '@/utils/commonFormats';
import { formatBytes, formatBytesToMB, formatDecimal } from '@/utils/formatBytes';

const formatters = {
  none: (value: number) => {
    return value.toString();
  },
  percent: (value: number) => {
    return `${Math.round(value * 100) / 100}%`;
  },
  seconds: (value: number) => {
    return formatDuration(value);
  },
  thousandSeparatedCount: (value: number) => {
    return formatNumber(value);
  },
  bytes: (value: number) => {
    return formatBytes(value);
  },
  bytesToMB: (value: number) => {
    return formatBytesToMB(value);
  },
  secondsToHours: (value: number) => {
    return secondsToHours(value);
  },
  secondsToMinutes: (value: number) => {
    return secondsToMinutes(value);
  },
  gigabytePerSecond: (value: number) => {
    return `${formatDecimal(value)} GB/s`;
  },
  gigabitPerSecond: (value: number) => {
    return `${formatDecimal(value)} Gbit/s`;
  },
  gibibyte: (value: number) => {
    return `${formatDecimal(value)} GiB`;
  },
};

const getFormattedValue = (unit: TypeMetricUnit, value?: null | number, fallbackValue?: string): string => {
  const formatter = formatters[unit];

  if (value === null || value === undefined || !Number.isFinite(value)) {
    return fallbackValue ?? 'N/A';
  }

  return formatter(value);
};

export default getFormattedValue;
